import http from '../http';
import { API_BASE_URL } from '../../config';


export default class AdminService {
  static loginOwner(payload) {
    return http.post(`${API_BASE_URL}/v2/auth/owners/login`, payload);
  }
  static updateLocation(id, payload) {
    return http
      .put(`${API_BASE_URL}/v2/locations/${id}`, payload)
      .then((response) => response.data);
  }

  static getOwners() {
    const config = {
      params: {
        isOwner: true,
      }
    }
    return http
      .get(`${API_BASE_URL}/v2/owners`, config)
      .then((response) => response);
  }

  static getOwnersPg(page, limit, searchQuery) {
    const config = {
      params: {
        isOwner: true,
        page,
        limit,
      }
    }
    const data = {
      ...searchQuery
    };
    console.log("config", config)
    console.log("data", searchQuery)
    return http
      .post(`${API_BASE_URL}/v2/owners`, data, config)
      .then((response) => response);
  }

  static getDrivers() {
    const config = {
      params: {
        isDriver: true
      }
    }
    return http
      .get(`${API_BASE_URL}/v2/owners`, config)
      .then((response) => response);
  }
  static getDriversPg(page, limit, searchQuery) {
    const config = {
      params: {
        isDriver: true,
        page,
        limit,
      }
    }
    const data = {
      
      ...searchQuery,
    };
    return http
      .post(`${API_BASE_URL}/v2/owners`, data, config)
      .then((response => response));
  }

  static updateDriverRideShareAccess(driverId, enabled) {
    return http
      .patch(`${API_BASE_URL}/v2/admin/drivers/${driverId}/rideshare-access`, {
        enabled,
      })
      .then(response => response.data);
  }

  static getGlobalDriverRideShareAccess() {
    return http
      .get(`${API_BASE_URL}/v2/admin/rideshare-access/driver`)
      .then(response => response.data);
  }

  static updateGlobalDriverRideShareAccess(enabled) {
    return http
      .patch(`${API_BASE_URL}/v2/admin/rideshare-access/driver`, {
        enabled,
      })
      .then(response => response.data);
  }

  static getOwnerProfile(ownerId) {
    return http
      .get(`${API_BASE_URL}/v2/owners/${ownerId}`)
      .then((response) => response.data);
  }
  static logout() {
    return http
      .post(`${API_BASE_URL}/v2/auth/owners/logout`)
      .then((response) => response);
  }

  static forgotPassword(type, payload) {
    return http.post(`${API_BASE_URL}/v2/${type}s/reset-password/send-otp`, payload);
  }

  static resetOwnerPassword(token, payload) {
    return http.post(`${API_BASE_URL}/v2/owners/reset-password/${token}`, payload);
  }

  static resetPasswordByOTP(token, payload) {
    return http.post(`${API_BASE_URL}/v2/reset-password/mobile`, payload);
  }

  static signUp(payload) {
    return http.post(`${API_BASE_URL}/v2/auth/owners/sign-up`, payload);
  }
  // static updateProfile(id, payload) {

  //   return http
  //     .put(`${API_BASE_URL}/owners/${id}`, payload)
  //     .then((response) => response);
  // }
  static updateProfile(id, payload) {
    // console.log("Payload being sent:", JSON.stringify(payload, null, 2));// for chcecking the payload
    return http
      .put(`${API_BASE_URL}/v2/owners/profile/${id}`, payload)
      .then((response) => response);
  }

  static verifyOTP(userId, payload) {
    return http.put(`${API_BASE_URL}/v2/auth/owners/mobile/verify/${userId}`, payload);
  }
  static verifyOTPWhenForgetPassword(payload) {
    return http.post(
      `${API_BASE_URL}/v2/owners/forgot-password/otp/verify`,
      payload,
    );
  }

  static verifySocialAccount(payload, type) {
    console.log(type, payload);
    return http.post(`${API_BASE_URL}/v2/auth/${type}/callback/mobile`, payload);
  }

  static getCurrentUser() {
    return http
      .get(`${API_BASE_URL}/v2/auth/current-user`)
      .then((response) => response.data);
  }

  static updateFirebaseToken(payload) {
    return http
      .put(`${API_BASE_URL}/v2/firebase`, payload)
      .then((response) => response.data);
  }

  static uploadProfilePicture = (userId, payload) => {
    return http
      .post(`${API_BASE_URL}/v2/users/${userId}/picture`, payload)
      .then((res) => res.data);
  };

  static uploadImage = (payload) => {
    return http
      .post(`${API_BASE_URL}/v2/upload/private/s3`, payload)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log('upload', err);
      });
  };
  static updateMobile = (userId, payload) =>
    http.put(`${API_BASE_URL}/v2/users/mobile/${userId}`, payload);

  static removeMobile(user) {
    return http.put(`${API_BASE_URL}/v2/users/remove-mobile/${user._id}`, user);
  }

  static isRegistered = () =>
    http.get(`${API_BASE_URL}/v2/scholarship/registered`).then((res) => res.data);

  static isExistUser = (mobile) =>
    http.get(`${API_BASE_URL}/v2/auth/owners/exists/${mobile}`).then((res) => res.data);

  static isExistSession = () =>
    http.get(`${API_BASE_URL}/v2/auth/check/session`).then((res) => res.data);

  // TODO  location api
  static getLocations() {
    return http
      .get(`${API_BASE_URL}/v2/locations?type=subDistrict`)
      .then((response) => response.data);
  }
  //  TODO fare api
  static addFare(payload) {
    return http.post(`${API_BASE_URL}/v2/fares`, payload);
  }

  static getFareChart(params) {
    const config = {
      params
    }
    return http.get(`${API_BASE_URL}/v2/fares`, config);
  }

  static updateFare(fareId, payload) {
    return http.put(`${API_BASE_URL}/v2/fares/${fareId}`, payload);
  }

  static getFareConfigV2() {
    return http.get(`${API_BASE_URL}/v2/admin/fare/config`).then((response) => response);
  }

  static updateFareConfigV2(payload) {
    return http.patch(`${API_BASE_URL}/v2/admin/fare/config`, payload).then((response) => response);
  }

  static getRentalFareConfig() {
    return http.get(`${API_BASE_URL}/v2/admin/rental-fare/config`).then((response) => response.data);
  }

  static updateRentalFareConfig(payload) {
    return http.put(`${API_BASE_URL}/v2/admin/rental-fare/config`, payload).then((response) => response.data);
  }

  static dashBoardData() {
    return http.get(`${API_BASE_URL}/v2/dashboardData`);
  }
  static dashBoardData(page, limit) {
    return http.get(`${API_BASE_URL}/v2/dashboardData`, {
      params: { page, limit }
    });
  }

  static bids(params) {
    return http.get(`${API_BASE_URL}/v2/trips/${params}/bids`);
  }

}
